import { useSenderEmailValidList } from 'shared/components/sender-email-select/hooks/use-sender-email-valid-list'
import useUser from 'shared/hooks/use-user'
import { useSubstituteEmails } from './use-substitute-emails'

export const useNormalizeSenderEmail = () => {
  const { user } = useUser()
  const { data: senderEmailValidList } = useSenderEmailValidList()
  const { substituteEmails } = useSubstituteEmails()

  const userAccountEmail = user?.mainUser?.user.email

  const isReadyToNormalize = !!userAccountEmail && !!senderEmailValidList && !!substituteEmails

  const normalizeSenderEmail = (email: string): string => {
    if (!isReadyToNormalize) return email
    const isUserAccountEmail = userAccountEmail === email
    const isEmailValid = senderEmailValidList.some(item => item.email === email)
    const substituteEmail = substituteEmails[email]

    // https://systeme-team.slack.com/archives/C074L362C2C/p1761563628961429?thread_ts=1761317551.346699&cid=C074L362C2C
    if (isUserAccountEmail && !isEmailValid && substituteEmail) {
      return ''
    }
    return email
  }

  return {
    isReadyToNormalize,
    normalizeSenderEmail,
  }
}
